import 'css-chunksrc/client/pages/projectPage/resourcesPage/resource/tagsList/styles.scss';export default {
  "tagsList": "_tagsList_86y7k_1",
  "hiddenTags": "_hiddenTags_86y7k_8",
  "infoBox": "_infoBox_86y7k_16",
  "slideIn": "_slideIn_86y7k_1",
  "number": "_number_86y7k_24",
  "arrow": "_arrow_86y7k_30"
};